import { render, staticRenderFns } from "./stopReviewList.vue?vue&type=template&id=0e82e5f9&scoped=true"
import script from "./stopReviewList.vue?vue&type=script&lang=js"
export * from "./stopReviewList.vue?vue&type=script&lang=js"
import style0 from "./stopReviewList.vue?vue&type=style&index=0&id=0e82e5f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82e5f9",
  null
  
)

export default component.exports